// Helpers puros sobre localStorage para el segundo punto de captación del
// newsletter (soft-ask contextual, no bloqueante). Todo acceso es defensivo
// porque este módulo puede importarse desde código que corre durante SSR/
// hidratación (Next.js) donde `window`/`localStorage` no existen o pueden
// lanzar (modo privado, storage deshabilitado, etc).

const SHOWN_KEY = "newsletter_soft_ask_shown";
const INTEREST_COUNT_KEY = "newsletter_soft_ask_interest_count";
const COMUNA_COUNTS_KEY = "newsletter_soft_ask_comuna_counts";

function safeGetItem(key: string): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSetItem(key: string, value: string): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Storage no disponible (modo privado, cuota, etc) — no es crítico,
    // simplemente no persiste y en el peor caso se vuelve a mostrar.
  }
}

export function hasShownNewsletterSoftAsk(): boolean {
  return safeGetItem(SHOWN_KEY) === "1";
}

export function markNewsletterSoftAskShown(): void {
  safeSetItem(SHOWN_KEY, "1");
}

export function recordInterestClick(): number {
  const raw = safeGetItem(INTEREST_COUNT_KEY);
  const current = raw ? parseInt(raw, 10) || 0 : 0;
  const next = current + 1;
  safeSetItem(INTEREST_COUNT_KEY, String(next));
  return next;
}

export function recordComunaFilter(comuna: string): number {
  const raw = safeGetItem(COMUNA_COUNTS_KEY);
  let counts: Record<string, number> = {};
  if (raw) {
    try {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") counts = parsed;
    } catch {
      counts = {};
    }
  }
  const next = (counts[comuna] ?? 0) + 1;
  counts[comuna] = next;
  safeSetItem(COMUNA_COUNTS_KEY, JSON.stringify(counts));
  return next;
}
